import React from 'react';
import {motion} from 'framer-motion';
import LinearProgress from '@material-ui/core/LinearProgress';
import {fadeInOut} from '../common';

export default function LinearProgressLoader({className = 'card__loader'}) {
    return (
        <motion.div className={className} {...fadeInOut()}>
            <LinearProgress
                classes={{
                    root: 'loading loading--progress',
                    bar: 'loading__bar',
                }}
            />
        </motion.div>
    );
}
